import config from '../config';

const trueFit = config({
  default: {
    default: {
      /** Whether the True Fit integration is enabled. */
      enabled: false,
      /** The clientID for the True Fit account. */
      clientID: '',
      /** Can be 'fitrec' or 'tf-integration'. */
      library: 'fitrec',
      /** The environment to use. Can be 'staging' or 'prod' or 'dev'. */
      environment: { default: 'prod', prod: 'prod' }
    }
  },
  'HOKA-US': { default: { enabled: true, clientID: 'hok' } },
  'UGG-US': { default: { clientID: 'ugg' } },
  'TEVA-US': { default: { clientID: 'tva' } }
});

export default trueFit;
